import {MaxiDingConfig} from "../configuration/configurations";

const TOKEN_KEY = 'djxy_auth_token';

export function userLogout() {
    removeToken();
}

export function hasToken() {
    return !!getToken();
}

const saveToken = (token) => {
    localStorage.setItem(TOKEN_KEY, token);
}

const removeToken = () => {
    localStorage.removeItem(TOKEN_KEY);
}

const getToken = () => {
    return localStorage.getItem(TOKEN_KEY);
}

export const userLogin = (username, password) => {
    const requestBody = JSON.stringify({
        username,
        password,
    });
    return fetch(MaxiDingConfig.loginUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: requestBody,
    });
}


